import api from '../http-common';

//faq settings builder

const getFaqBuilderOptions = () => api.post('/settings/faq/get-options-data');

const getFaqDataSettings = () => api.post('/settings/faq/edit');

const updateFaqSettings = (data?) => api.post('/settings/faq/update', data);

//faq

const getFaqIndex = (data?) => api.post('/faq/groups/index', data);

const getFaqOptions = () => api.post('/faq/groups/get-options-data');

const createFaqGroup = (data?) => api.post('/faq/groups/store', data);

const getListFaqGroupsSort = () => api.post('/faq/groups/sort');

const sortFaqGroups = (data?) => api.post('/faq/groups/sort/store', data);

const getFaqGroupEditData = (id?: string) => api.post(`/faq/groups/${id}/edit`);

const updateFaqGroup = (id?, data?) => api.post(`/faq/groups/${id}/update`, data);

const deleteFaqGroup = (id?) => api.post(`/faq/groups/${id}/delete`);

const getQuestionsListSort = (id?) =>
  api.post(`/faq/groups/${id}/questions/sort`);

const sortQuestionsInGroup = (id?, data?) =>
  api.post(`/faq/groups/${id}/questions/sort/store`, data);

const getFile = (data?) =>
  api.post('/faq/get-file', data);

const deleteFile = (data?) =>
  api.post('/faq/delete-file', data);

const FaqService = {
  getFaqBuilderOptions,
  getFaqDataSettings,
  updateFaqSettings,
  getFaqIndex,
  getFaqOptions,
  createFaqGroup,
  getListFaqGroupsSort,
  sortFaqGroups,
  getFaqGroupEditData,
  updateFaqGroup,
  deleteFaqGroup,
  getQuestionsListSort,
  sortQuestionsInGroup,
  getFile,
  deleteFile
};

export default FaqService;
